import React, { useState } from 'react';

import AttendanceSearchBody from './Body';
import Layout from '../Components/Layout';

export type TyAdvancedSearchAttendanceProps = {
  pageTitle: string
  setInitialValues: (values: object | undefined) => void
  initialValues: Record<string, object | undefined>
};

const TyAdvancedSearchAttendance: React.FC<TyAdvancedSearchAttendanceProps> = ({
  pageTitle = 'Kdo hledá ten najde',
  setInitialValues,
  initialValues,
}) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <Layout
      pageTitle={pageTitle}
      showModal={showModal}
      setShowModal={setShowModal}
      initialValues={initialValues}
      setInitialValues={setInitialValues}
    >
      <AttendanceSearchBody />
    </Layout>
  );
};

export default TyAdvancedSearchAttendance;
